module.exports = __webpack_public_path__ + "static/media/coxbazar.b4329bef.png";